import { useState, useEffect } from 'react';
import DeviceDetector from 'device-detector-js';

import { useWindowSize } from 'hooks';

const DEVICES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop'
};

const getDeviceSize = (width) => {
  if (width > 1025) {
    return DEVICES.DESKTOP;
  } if (width <= 1025 && width > 768) {
    return DEVICES.TABLET;
  } else {
    return DEVICES.MOBILE;
  }
};

const deviceDetector = new DeviceDetector();

const useDeviceInfo = () => {
  const windowSize = useWindowSize();

  const [ device, setDevice ] = useState();

  const { userAgent } = window.navigator;

  useEffect(() => {
    setDevice((prev) => ({
      ...prev,
      screenSize: getDeviceSize(windowSize.width)
    }));
  }, [ windowSize.width ]);

  useEffect(() => {
    const dev = deviceDetector.parse(userAgent);

    setDevice((prev) => ({
      ...prev,
      os: dev.os,
      browser: dev.client,
      device: dev.device
    }));
  }, [ userAgent ]);

  return device;
};

export default useDeviceInfo;
